<template>
  <BaseDialog
      title="EC在庫移動"
      width="60%"
      :visible.sync="dialogVisible"
      :show-only-close-button="false"
      :disable-ok-button="checkAmt || inputCheck"
      @cancel="cancel"
      @ok="save">
    <template slot="contents">
      <div class="dialog-contents">
        <template>
          <div class="inn-content">
            <el-row>
              <el-col :span="4">
                <div class="grid-content ">
                  <span>在庫種別</span>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content ">
                  <span>{{ detailData.stockName }}</span>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <div class="grid-content ">
                  <br>
                  <el-select v-model="detailData.siteCode"
                      size="mini">
                    <el-option
                        v-for="item in beforeSiteList"
                        :key="item.code"
                        :label="item.name"
                        :value="item.code" />
                  </el-select>
                </div>
              </el-col>
              <el-col :span="2"><div class="grid-content" /></el-col>
              <el-col :span="4">
                <div class="grid-content "
                    style="text-align:center">
                  <span>変更前</span>
                  <el-input-number
                      v-model="detailData.fromBeforeAmt"
                      size="mini"
                      :controls="false"
                      disabled="disabled" />
                </div>
              </el-col>
              <el-col :span="2"><div class="grid-content" /></el-col>
              <el-col :span="4">
                <div class="grid-content "
                    style="text-align:center">
                  <span>変更後</span>
                  <el-input-number
                      v-model="detailData.fromAfterAmt"
                      :min="1"
                      size="mini"
                      :controls="false"
                      @change="changeFromAfterAmt" />
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="2"
                  :offset="6">
                <div class="grid-content "
                    style="text-align:center;line-height: 28px;">
                  <span>移動数</span>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content "
                    style="text-align:center">
                  <el-input-number
                      v-model="detailData.transAmount"
                      size="mini"
                      :controls="false"
                      @change="changeTransAmount" />
                </div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content "
                    style="line-height: 28px;">
                  <span>（上限 {{ detailData.transMax }} )</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="grid-content "
                    style="line-height: 28px;">
                  <span v-if="checkAmt"
                      class="errorAmt is-error-msg">移動数は{{ detailData.transMax }}以下の正数で入力してください。</span>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <div class="grid-content "
                    style="text-align:center">
                  <el-select v-model="detailData.afterSiteCode"
                      size="mini"
                      @change="changeSite">
                    <el-option
                        v-for="item in afterSiteList"
                        :key="item.code"
                        :label="item.name"
                        :value="item.code" />
                  </el-select>
                </div>
              </el-col>
              <el-col :span="2"><div class="grid-content" /></el-col>
              <el-col :span="4">
                <div class="grid-content "
                    style="text-align:center">
                  <el-input-number
                      v-model="detailData.toBeforeAmt"
                      size="mini"
                      :controls="false"
                      disabled="disabled" />
                </div>
              </el-col>
              <el-col :span="2"><div class="grid-content" /></el-col>
              <el-col :span="4">
                <div class="grid-content "
                    style="text-align:center">
                  <el-input-number
                      v-model="detailData.toAfterAmt"
                      :min="1"
                      size="mini"
                      :controls="false"
                      @change="changeToAfterAmt" />
                </div>
              </el-col>
            </el-row>
          </div>
        </template>
      </div>
    </template>
  </BaseDialog>
</template>
<style>
  .input-label {
    font-size: 14px;
    font-weight: bold;
    color: #9da6ba;
    text-align: right;
    padding-right: 10px;
  }
  .inn-content {
    margin: 20px
  }
  .el-row:not(:first-child) {
    margin-bottom: 20px;
  }
  .el-col {
    border-radius: 4px;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
</style>

<script>
import _ from 'lodash'
import { mapState, mapGetters } from 'vuex'
import * as define from '@/define'
import * as query from '@/queries/stock'
import common from '@/utils/common'
import BaseDialog from '@/components/molecules/BaseDialog'
import * as config from '@/config'
import message from '@/utils/message'
export default {
  name: 'StockMoveDialog',
  components: {
    BaseDialog
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    keys: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      detailData: {},
      dialogVisible: false,
      beforeSiteList: [],
      afterSiteList: []
    }
  },
  computed: {
    define: () => define,
    ...mapState({
      sites: (state) => state.sites
    }),
    ...mapGetters({
      getServiceSiteConfig: 'getServiceSiteConfig'
    }),
    checkAmt () {
      return this.detailData.transAmount <= 0 ||
          this.detailData.transAmount > this.detailData.transMax
    },
    inputCheck () {
      return this.detailData.fromAfterAmt === undefined ||
          this.detailData.transAmount === undefined ||
          this.detailData.toAfterAmt === undefined ||
          this.detailData.afterSiteCode === ''
    }
  },
  watch: {
    async keys (val) {
      await this.getDetailData()
    }
  },
  created () {
  },
  methods: {
    /**
     * サイト(移動元)
     */
    getBeforeSiteList () {
      return this.sites.filter(site => {
        return (site.code === this.keys.siteCode)
      })
    },
    /**
     * サイト(移動先)
     */
    getAfterSiteList () {
      return this.sites.filter(site => {
        return (site.code !== this.keys.siteCode)
      })
    },
    /**
     * 在庫種別情報を返却します。
     * @param {Object} 情報
     * @returns {name} value値
     */
    stockType (stockType) {
      return _.get(
        this.getServiceSiteConfig(null, 'd_ec_stock', 'stock_type', stockType),
        'label'
      )
    },
    changeTransAmount () {
      // 在庫数(変更後)(移動元)に「在庫数(変更前)(移動元) － 移動数」をセット
      this.detailData.fromAfterAmt = this.detailData.fromBeforeAmt - this.detailData.transAmount
      // 在庫数(変更後)(移動先)に「在庫数(変更前)(移動先) ＋ 移動数」をセット
      this.detailData.toAfterAmt = this.detailData.toBeforeAmt + this.detailData.transAmount
    },
    changeFromAfterAmt () {
      // 移動数に「在庫数(変更前)(移動元) － 在庫数(変更後)(移動元)」をセット
      this.detailData.transAmount = this.detailData.fromBeforeAmt - this.detailData.fromAfterAmt
      // 在庫数(変更後)(移動先)に「在庫数(変更前)(移動先) ＋ 移動数」をセット
      this.detailData.toAfterAmt = this.detailData.toBeforeAmt + this.detailData.transAmount
    },
    changeToAfterAmt () {
      if (this.detailData.afterSiteCode !== '') {
        // 移動数に「在庫数(変更後)(移動先) － 在庫数(変更前)(移動先)」をセット
        this.detailData.transAmount = this.detailData.toAfterAmt - this.detailData.toBeforeAmt
        // 在庫数(変更後)(移動元)に「在庫数(変更前)(移動元) － 移動数」をセット
        this.detailData.fromAfterAmt = this.detailData.fromBeforeAmt - this.detailData.transAmount
      }
    },
    async changeSite () {
      try {
        const excQuery = common.addGraphQlCondition(query.GRAPH_QL_QUERY_EC_STOCK_LIST,
          { siteCodes: [this.detailData.afterSiteCode],
            stockTypes: [this.keys.stockType],
            withEmpty: 1,
            productIds: [this.keys.productId] })
        const res = await common.postGraphQl(excQuery)
        // 結果が null の場合
        if (res.data.data.ecStockListItems.edges.length < 1) {
          // 在庫数(変更前)(移動先)
          this.detailData.toBeforeAmt = 0
        } else {
          // DBから移動先の情報を取得
          let item = res.data.data.ecStockListItems.edges[0].node
          // 在庫数(変更前)(移動先)
          this.detailData.toBeforeAmt = item.ecStockDistr == null ? 0 : Number(item.ecStockDistr.amount)
        }
        // 在庫数(変更後)(移動先)
        if (this.detailData.transAmount !== undefined) {
          this.detailData.toAfterAmt = this.detailData.toBeforeAmt + this.detailData.transAmount
        }
      } catch (error) {
        throw error
      } finally {
        this.$loadingService.close()
      }
    },
    /**
     * ダイアログ詳細情報を取得します。
     */
    async getDetailData () {
      try {
        const excQuery = common.addGraphQlCondition(query.GRAPH_QL_QUERY_EC_STOCK_LIST,
          { siteCodes: [this.keys.siteCode.toString()],
            stockTypes: [this.keys.stockType],
            withEmpty: 1,
            productIds: [this.keys.productId] })
        const res = await common.postGraphQl(excQuery)
        // 結果が null の場合
        if (res.data.data.ecStockListItems.edges.length < 1) {
          this.$notify.error({
            message: 'データを取得できませんでした。'
          })
          return
        }
        // DBから詳細画面の情報を取得
        let item = res.data.data.ecStockListItems.edges[0].node

        // サイト(移動元)
        this.beforeSiteList = this.getBeforeSiteList()
        // サイト(移動先)
        this.afterSiteList = this.getAfterSiteList()

        // EC配分在庫の配分数、EC配分在庫が null の場合は配分数を 0
        const amount = item.ecStockDistr == null ? 0 : item.ecStockDistr.amount
        // EC在庫の公開数、EC在庫が null の場合は登録数を 0 とみなす
        const registered = item.ecStock == null ? 0 : item.ecStock.registered
        // 移動上限数を算出、公開数が null の場合は「-」を表示する。（無制限在庫なので移動できない）
        const transMax = registered == null ? '-' : Number(amount) - Number(registered)

        // 画面データを作成
        this.detailData = {
          stockType: item.stockType, // 在庫種別
          stockName: this.stockType(item.stockType.toString()), // 在庫種別名
          siteCode: item.site.code, // 移動元サイトコード
          afterSiteCode: '', // 移動先サイトコード
          productId: item.sku.product.code, // SKUコード
          skuUuid: item.sku.uuid, // 移動SKU識別ID
          fromBeforeAmt: amount, // 在庫数(変更前)(移動元)
          fromAfterAmt: undefined, // 在庫数(変更後)(移動元)
          transAmount: undefined, // 移動数
          transMax: transMax, // 移動上限数
          toBeforeAmt: undefined, // 在庫数(変更前)(移動元)
          toAfterAmt: undefined // 在庫数(変更後)(移動元)
        }
        // ダイアログを表示にする
        this.dialogVisible = true

        console.log(JSON.stringify(this.detailData))
      } catch (error) {
        throw error
      } finally {
        this.$loadingService.close()
      }
    },
    /**
     * EC在庫移動中止
     */
    cancel () {
      this.$log.debug('モーダル中止処理')
      this.doDestroyed()
    },
    /**
     * EC在庫移動保存
     */
    async save () {
      this.$confirm('保存しますか？', define.MESSAGE_TITLE, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(async () => {
        try {
          this.$loadingService.show()
          // URLの準備
          const url = config.EC_STOCK + '/' +
            this.detailData.siteCode + '/' +
            this.detailData.stockType + '/' +
            this.detailData.skuUuid + '/move'
          // メソッド
          const method = 'post'
          // REQUEST BODYの準備
          const data = {
            'siteCode': this.detailData.afterSiteCode,
            'amount': this.detailData.transAmount
          }

          // EC配分在庫移動APIを呼び出す
          await common.apiAxios(url, { method, data })
          this.$notify.success('保存しました。')

          // ダイアログdestroy
          this.doDestroyed()
          this.$emit('saved', this.keys)
        } catch (error) {
          const data = _.get(error, 'response.data')
          if (data == null) {
            common.addError(error, { msg: message.MSG_502() })
          }
          this.$notify.error({ error: error })
          throw error
        } finally {
          this.$loadingService.close()
        }
      }).catch(() => {
        this.$notify.info('キャンセルしました。')
      })
    },
    /**
     * ダイアログdestroy
     */
    doDestroyed () {
      this.$log.debug('ダイアログクローズ')
      this.dialogVisible = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/stock/StockMoveDialog.vue